/* LP — Leads. Entrance + scroll motion. GSAP + ScrollTrigger (staged in assets). */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.querySelector('.lp');
  if (!root) return;

  if (reduced || typeof window.gsap === 'undefined') {
    // No motion: make everything visible and stop.
    root.classList.add('lp--no-motion');
    return;
  }

  var gsap = window.gsap;
  if (window.ScrollTrigger) {
    gsap.registerPlugin(window.ScrollTrigger);
    /* iOS: address-bar show/hide fires resize -> ScrollTrigger refresh
       mid-scroll, re-basing pin distances while baked tween values keep the
       old viewport height — the form's straight side-entry turns diagonal.
       Ignore those toolbar resizes entirely. */
    window.ScrollTrigger.config({ ignoreMobileResize: true });
  }

  var isMobile = window.matchMedia('(max-width: 1023px)').matches;

  /* Lenis everywhere — same engine as the reference site.
     Desktop: wheel smoothing. Mobile: syncTouch — Lenis owns the touch
     scroll, so scroll position and the scrubbed pins/tweens update in the
     SAME rAF. Native iOS scroll moves the compositor before scroll events
     fire, and that lag is exactly the shake / finger-drag on the form's
     side-entry. One clock for both = lockstep. */
  var lenis = null;
  if (window.Lenis) {
    lenis = new window.Lenis(isMobile
      ? { syncTouch: true, touchMultiplier: 1.4 }   /* fewer swipes per section */
      : { duration: 1.1 });
    lenis.on('scroll', window.ScrollTrigger ? window.ScrollTrigger.update : function () {});
    gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
    gsap.ticker.lagSmoothing(0);
  }

  /* Hero entrance — staggered rise on load */
  gsap.to('[data-hero-el]', {
    opacity: 1,
    y: 0,
    duration: 0.7,
    stagger: 0.12,
    ease: 'power3.out',
    delay: 0.15
  });

  /* About: static text — no word animation, no product squares. The section
     still pins, because the work section is pulled up -100svh by .lp--curtain
     and rises over About across the pinned stretch. The pin spacer sets when
     that rise starts: work top == About top + pinDistance - 100svh, so
     +=200% gives one viewport of the text held still, then one viewport of
     curtain, landing work at 'top top' exactly as its own pin takes over. */
  if (window.ScrollTrigger) {
    /* every LP variant gets the height lock + the lead-form curtain */
    document.querySelector('.lp').classList.add('lp--curtain');

    /* Whichever section sits above the work curtain is pinned for it: About
       on variant A, the business card on variant B. Both are exactly one
       viewport tall, so work — pulled up -100svh — rises over the pinned
       section across the pin's second viewport and lands at 'top top' just
       as its own pin takes over. Without this the work section scrolls in
       under its own height lock and the gallery gets clipped mid-frame. */
    var curtainAnchor = document.querySelector('.lp-about') || document.querySelector('.lp-biz');
    if (curtainAnchor) {
      document.querySelector('.lp').classList.add('lp--curtain-over');
      ScrollTrigger.create({
        trigger: curtainAnchor,
        start: 'top top',
        /* exactly one viewport — the pull-up distance and nothing more. Any
           extra is dead scroll: the section is pinned, the curtain has not
           started, so the page stops responding and it reads as a snap.
           anticipatePin is off for the same reason — it pins a few px early,
           which is a visible hitch on a trackpad. */
        end: '+=100%',
        pin: true,
        invalidateOnRefresh: true
      });
    }
  }

  /* Business block (variant B): everything is scrubbed — the block assembles
     at exactly the speed the user scrolls, and runs backwards when they
     scroll back up. No duration, no ease-in-time: scroll position IS time. */
  if (document.querySelector('.lp-biz') && window.ScrollTrigger) {
    var bizTl = gsap.timeline({
      scrollTrigger: {
        /* the whole entrance runs between the card entering the frame and
           the card reaching the top — i.e. it is finished by the time the
           pin starts, so pinning never fights the scrub */
        trigger: '.lp-biz',
        start: 'top 92%',
        end: 'top top',
        scrub: true,
        invalidateOnRefresh: true
      }
    });

    /* media: oversized, settles to its frame as the block arrives */
    bizTl.fromTo('.lp-biz__media img',
      { scale: 1.18, yPercent: -4 },
      { scale: 1, yPercent: 0, ease: 'none', duration: 1 }, 0);

    /* copy: each element rises out of the navy on its own slice of scroll */
    gsap.utils.toArray('[data-biz-el]').forEach(function (el, i) {
      bizTl.fromTo(el,
        { opacity: 0, y: 42 },
        { opacity: 1, y: 0, ease: 'none', duration: 0.5 },
        i * 0.16);
    });
  }

  /* Depth: hero image parallax — the image drifts slower than the page */
  if (window.ScrollTrigger) {
    gsap.to('.lp-hero__media img', {
      yPercent: 12,
      ease: 'none',
      scrollTrigger: { trigger: '.lp-hero', start: 'top top', end: 'bottom top', scrub: true }
    });
  }

  /* Sticky header: bg + quote CTA appear once the hero is passed */
  if (window.ScrollTrigger) {
    window.ScrollTrigger.create({
      trigger: '.lp-hero',
      start: 'bottom top',
      onEnter: function () { document.querySelector('.lp-topbar').classList.add('lp-topbar--scrolled'); },
      onLeaveBack: function () { document.querySelector('.lp-topbar').classList.remove('lp-topbar--scrolled'); }
    });
  }

  /* Scroll progress rail — thumb rides the physical right edge */
  var progressThumb = document.querySelector('.lp-progress__thumb');
  if (progressThumb && window.ScrollTrigger) {
    var progressRail = progressThumb.parentElement;
    var railIdleTimer = null;
    window.ScrollTrigger.create({
      start: 0,
      end: 'max',
      onUpdate: function (self) {
        var travel = progressRail.offsetHeight - progressThumb.offsetHeight;
        progressThumb.style.transform = 'translateY(' + (self.progress * travel) + 'px)';
        /* reference behavior: visible while scrolling, fades after ~2.5s idle */
        progressRail.classList.add('lp-progress--visible');
        if (railIdleTimer) clearTimeout(railIdleTimer);
        railIdleTimer = setTimeout(function () {
          progressRail.classList.remove('lp-progress--visible');
        }, 2500);
      }
    });
  }

  /* Work section: once fully in frame, pin. Phase A (0-70vh of the pin):
     the container collapses. Phase B (70-170vh): the lead form slides in
     from the side. The form is pulled up by -100vh margin, so during phase B
     the document raises it 100vh→0; a linear y tween (-100vh→0) cancels that
     rise exactly, leaving pure horizontal motion. x/y both ease:none so the
     cancellation holds at every scroll position, and everything lands at
     identity precisely at pin release — seamless handoff to normal flow. */
  var workPinST = null;
  if (window.ScrollTrigger && document.querySelector('.lp-work__inner')) {
    /* ONE source of truth for the curtain unit. The form's y-tween must cancel
       the document's rise exactly; that only holds if the pin's scroll distance
       and the tween's travel come from the SAME number as the -100svh pull-up.
       window.innerHeight is NOT that number on iOS — it tracks the dynamic
       toolbar while svh does not, and the gap (~toolbar height) is the offset
       and finger-drag you see. Measure the section instead. */
    var leadUnitEl = document.querySelector('.lp-lead');
    /* the pull-up itself — not the section height, which can exceed svh when
       the form content is taller than one small-viewport frame */
    var curtainUnit = function () {
      return Math.abs(parseFloat(getComputedStyle(leadUnitEl).marginTop)) || window.innerHeight;
    };

    /* mobile: shorter collapse phase; phase B (the side entry) must stay
       exactly ONE curtain-unit of scroll for the y-cancellation, so the pin
       distance is unit * (collapseDur + 1.0) by construction */
    var collapseDur = isMobile ? 0.35 : 0.7;
    var workIdle = 0.45;   /* beat with the gallery at rest before it shrinks */
    var workTotal = workIdle + collapseDur + 1.0;
    var workTl = gsap.timeline({
      scrollTrigger: {
        trigger: '.lp-work',
        start: 'top top',
        end: isMobile
          ? function () { return '+=' + (curtainUnit() * workTotal); }
          : '+=' + Math.round(workTotal * 100) + '%',
        pin: true,
        /* exact scrub: the form's y-cancellation must track real scroll
           1:1 — a lagged scrub breaks the horizontal illusion */
        scrub: true,
        anticipatePin: 1,
        invalidateOnRefresh: true,
        /* form docked = quote CTA is redundant; bring it back when the
           user scrolls back up out of the form */
        onLeave: function () { document.querySelector('.lp-topbar').classList.add('lp-topbar--hide-cta'); },
        onEnterBack: function () { document.querySelector('.lp-topbar').classList.remove('lp-topbar--hide-cta'); }
      }
    })
      .to('.lp-work__inner', { scale: 0.82, ease: 'none', duration: collapseDur }, workIdle)
      .fromTo('.lp-lead',
        /* y travel == curtainUnit() == the pull-up == phase-B scroll distance.
           All three from one measurement, so the cancellation is exact on any
           device. force3D keeps the slide on the compositor (no repaint
           stutter under a finger drag). */
        {
          x: function () { return -window.innerWidth; },
          y: function () { return isMobile ? -curtainUnit() : -window.innerHeight; }
        },
        { x: 0, y: 0, ease: 'none', force3D: true, duration: 1.0 },
        workIdle + collapseDur
      );
    workPinST = workTl.scrollTrigger;
  }

  /* Scroll reveals — each element rises as it enters */
  if (window.ScrollTrigger) {
    gsap.utils.toArray('[data-reveal]').forEach(function (el) {
      gsap.to(el, {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 85%',
          once: true
        }
      });
    });
  } else {
    gsap.to('[data-reveal]', { opacity: 1, y: 0, duration: 0.6 });
  }

  /* Smooth-scroll the CTAs to the form. The form only becomes visible at
     the END of the work pin (it slides in during the pin's last stretch),
     so the correct destination is the pin's end scroll position — the
     element's document offset would land mid-pin, on the projects. */
  document.querySelectorAll('a[href="#lead-form"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var dest;
      if (workPinST) dest = workPinST.end;
      else dest = document.getElementById('lead-form');
      if (!dest && dest !== 0) return;
      if (lenis) lenis.scrollTo(dest);
      else if (typeof dest === 'number') window.scrollTo({ top: dest, behavior: 'smooth' });
      else dest.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
})();
